import React from 'react';
import { Card, Form, Select, Row, Col } from 'antd';
import { FormInstance } from 'antd/es/form';

const { Option } = Select;

interface TerminationProps {
  form: FormInstance;
}

const Termination: React.FC<TerminationProps> = ({ form }) => {
  const yesNoOptions = ['Yes', 'No'];

  return (
    <Card title="Termination" style={{ marginBottom: 16 }}>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Were you qualified for the job?"
            name={['termination_info', 'were_qualified']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Did you satisfy the requirements of the job?"
            name={['termination_info', 'satisfied_requirements']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Were you replaced?"
            name={['termination_info', 'were_replaced']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Was the person who replaced you the same basis?"
            name={['termination_info', 'replacement_same_basis']}
          >
            <Select placeholder="Select">
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};

export default Termination;

